const hoverBackgroundColor = '#00729a';

export default {
  colors: {
    mainOrange: '#eb7100',
    orange: ['#eb7100', '#ef8d32', '#f3aa67', '#f7c698', '#f4c092', '#f7d6b9', '#fce8d6'],
    blue: ['#00729a', '#308cac', '#62a6be', '#92c0d0', '#aadde0', '#afc6cE', '#d5dde0'],
    white: '#ffffff',
    barChartColors: [
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#ffffff',
    ],
    barChartBorderColors: [
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#eb7100',
      '#dcdcdc',
    ],
    barChartHoverBorderColors: [
      '#00729a',
      '#00729a',
      '#00729a',
      '#00729a',
      '#00729a',
      '#00729a',
      '#00729a',
      '#00729a',
      '#00729a',
      '#00729a',
      '#00729a',
      '#00729a',
      '#00729a',
      '#00729a',
      '#dcdcdc',
    ],
    hoverBackgroundColor,
  },
  pieChartOptions: {
    borderWidth: 1,
    hoverBorderWidth: 1,
    borderColor: '#fff',
    hoverBorderColor: '#fff',
  },
  druglikenessChart: {
    // List of radar themes
    components: {
      substance: {
        type: 'area',
        name: 'Substance',
        color: '#ff6c00',
        fillColor: 'rgba(233, 113, 27, .2)',
        marker: {
          fillColor: '#fff',
          lineColor: '#ff6c00',
          lineWidth: 1,
          radius: 3,
        },
        pointPlacement: 'on',
        stickyTracking: false,
      },
      rules: {
        type: 'area',
        name: 'Lipinski/Veber rules',
        pointPlacement: 'on',
        marker: { enabled: false },
        color: '#00729a',
        fillColor: 'transparent',
        enableMouseTracking: false,
      },
    },
  },
  barChartOptions: {
    font: {
      fontSize: '14px',
      fontFamily: 'NexusSans,"Helvetica Neue",Helvetica,Arial,sans-serif',
    },
    plotOptions: {
      column: {
        pointPadding: 0.02,
        groupPadding: 0,
        borderWidth: 1,
        colorByPoint: true,
        states: {
          hover: {
            color: hoverBackgroundColor,
          },
        },
      },
    },
  },
};
